import {useEffect} from 'react'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {CoordinatorsListHeader} from './components/header/CoordinatorsListHeader'
import {CoordinatorsTable} from './table/CoordinatorsTable'
import {CoordinatorEditModal} from './coordinators-edit-modal/CoordinatorEditModal'
import {PageCard} from '../../../../components/design-system'
import {useQueryResponse} from '../coordinator-list/core/QueryResponseProvider'
import {on, off} from '../../../../helpers/events'

type PropTypes = {
  /** Shows the [Add User] button inside the header on the top right corner */
  showAddCoordinator?: boolean
  /** An array of columns that you don't want shown in the user list */
  hiddenColumns?: string[]
}

export const COORDINATORS_REFRESH = 'COORDINATORS_REFRESH'

const CoordinatorsList = ({showAddCoordinator = true, hiddenColumns = []}: PropTypes) => {
  const {itemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()

  useEffect(() => {
    on(COORDINATORS_REFRESH, refetch)
    return () => {
      off(COORDINATORS_REFRESH, refetch)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <PageCard style={{padding: 0, overflow: 'hidden'}}>
        <CoordinatorsListHeader showAddCoordinator={showAddCoordinator} />
        <CoordinatorsTable hiddenColumns={hiddenColumns} />
      </PageCard>
      {itemIdForUpdate !== undefined && <CoordinatorEditModal />}
    </>
  )
}

const CoordinatorsListWrapper = ({showAddCoordinator = true, hiddenColumns = []}: PropTypes) => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <CoordinatorsList showAddCoordinator={showAddCoordinator} hiddenColumns={hiddenColumns} />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {CoordinatorsListWrapper}
